
import { Base } from '../../components/base-component';

import './calculator-personalloans-v2-form.component.scss';

export class CalculatorPersonalloansV2Form extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/calculator-personalloans-v2-form/calculator-personalloans-v2-form.component.ts